var i = function i(_i) {
  return _i.isMultiline;
},
    l = function l(i) {
  return !i.isMultiline;
},
    t = function t(i, l) {
  return !i.isMultiline;
},
    e = function e(i, l) {
  return i.isMultiline;
};

export { l as isInputField, t as isInputRef, i as isTextAreaField, e as isTextAreaRef };